import LayoutBasic from "@/views/layouts/LayoutBasic";
import PostUsers from "@/views/services/PostUsers.vue";
import Proxies from "@/views/services/Proxies.vue";
import MarketPlaces from "@/views/services/MarketPlaces.vue";

const routes = {
  path: '/services',
  component: LayoutBasic, // Change the desired Layout here,
  meta: {requiresAuth: true},
  children: [
    {
      path: 'postusers',
      component: PostUsers,
      name: 'ServicePostUsers',
      meta: {
        permission: 'services/postUsers'
      }
    },
    {
      path: 'proxies',
      component: Proxies,
      name: 'ServiceProxies',
      meta: {
        permission: 'services/proxies'
      }
    },
    {
      path: 'marketplaces',
      component: MarketPlaces,
      name: 'MarketPlaces',
      meta: {
        permission: 'services/proxies'
      }
    },
  ]
}

export default routes;
